export { default } from "./InputLabel";
